import React, { useMemo } from 'react';
import MaterialTable from 'material-table';
import EditIcon from '@material-ui/icons/Edit';
import ShareIcon from '@material-ui/icons/Share';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import BlockIcon from '@material-ui/icons/Block';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import styles from './styles';
import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.any,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array,
  handleCancel: PropTypes.func.isRequired,
  handleVerify: PropTypes.func.isRequired,
  handleCopyLink: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

const defaultProps = {
  title: null,
  data: [],
  columns: [],
  handleCancel:   ()=>{},
  handleVerify:   ()=>{},
  handleCopyLink: ()=>{},
  onEdit:         ()=>{},
};

function OrdersDataTable({
  title,
  data,
  handleCancel,
  handleVerify,
  handleCopyLink,
  onEdit
}) {

  const insertedAt = (insertedAt) => {
    if (insertedAt != null) {
      const date = new Date(insertedAt);
      return date.toLocaleString();
    }
    return '';
  };

  const dueDatetime = (due_datetime) => {
    if (due_datetime != null) {
      const date = new Date(due_datetime);
      const day = date.getDate();
      const month = (date.getMonth() + 1);
      const year = date.getFullYear();
      return (day < 10 ? '0' + day : day) + '.' + (month < 10 ? ('0' + month) : month) + '.' + year;
    }
    return '';
  };

  const userLinkElement = (user) => (
    <Link
      className="nav-link"
      to={{
        pathname: '/dashboard/users/' + user.id + '/edit',
      }}
    >
      {user.display_name} ({user.phone_number})
    </Link>
  );


  const renderActionButtons = (order) => (
    <div  style={{width: '50px'}}>
      <ButtonGroup variant="outlined" size="small">
        <Button
          style={{
            ...styles.button,
            ...styles.buttonBlue,
          }}
          onClick={() => onEdit(order)}
        ><EditIcon/></Button>
        <Button
          onClick={() => handleCopyLink(order.share_url)}
        ><ShareIcon/></Button>
      </ButtonGroup>
      <ButtonGroup size="small" variant="outlined">
        {order.status === 'pending' && <Button
          style={{
            ...styles.button,
            ...styles.buttonSuccess,
          }}
          onClick={() => handleVerify(order)}
        ><CheckBoxIcon/></Button>}
        {order.status === 'pending' && <Button
          style={{
            ...styles.button,
            ...styles.buttonRed,
          }}
          onClick={() => handleCancel(order)}
        ><BlockIcon/></Button>}
        {(order.status === 'available' || order.status === 'active') && <Button
          style={{
            ...styles.button,
            ...styles.buttonRed,
          }}
          onClick={() => handleCancel(order)}
        ><BlockIcon/></Button>}
      </ButtonGroup>
    </div>
  );

  const columns = useMemo(() => ([
    {
      field: 'id',
      title: 'ActiveNew',
      sorting: false,
      search: false,
      width: 100,
      render: rowData => (renderActionButtons(rowData))
    },
    {
      field: 'id',
      title: 'id',
      width: 100,
    },
    {
      field: 'status',
      title: 'Статус',
      width: 100,
    },
    {
      field: 'skill.name',
      title: 'Категория',
      width: 150
    },
    {
      field: 'city.name',
      title: 'Город',
      width: 150
    },
    {
      field: 'id',
      title: 'Клиент',
      render: rowData => (userLinkElement(rowData.consumer)),
      width: 150
    },
    {
      field: 'budget',
      title: 'Бюджет',
      width: 150

    },
    {
      field: 'due_datetime',
      title: 'Дата выполнения',
      render: rowData => (dueDatetime(rowData.due_datetime)),
      width: 150
    },
    {
      field: 'inserted_at',
      title: 'Дата создания',
      render: rowData => (insertedAt(rowData.inserted_at)),
      width: 200
    },
    {
      field: 'description',
      title: 'Комментарий',
      maxWidth: 200,
      render: rowData => (
        <p style={{
          width: '200px'
        }}>
          <strong>{rowData.description}</strong>
          <br/>
          {
            rowData.photos.map((eachPhoto) =>
              <a href={eachPhoto.original_url} target="_blank">
                <img alt="" src={eachPhoto.thumb_url} width="50" height="50"/>
              </a>
            )
          }
        </p>
      )
    },
    {
      field: 'order_bids',
      title: 'Отклики',
      render: rowData => (rowData.order_bids.map((orderBid) => (userLinkElement(orderBid.performer)))),
      width: 200
    },
  ]), []);

  return (
    <MaterialTable
      title={title}
      columns={columns}
      options={{
        rowStyle: {
          textAlign: 'left',
          verticalAlign: 'top',
        },
        search: false,
        actionsColumnIndex: 0,
        // pageSize: 100,
        // pageSizeOptions: [100,300,900],
        paging: false,
      }}
      data={data}
    />
  );
}
OrdersDataTable.propTypes = propTypes;
OrdersDataTable.defaultProps = defaultProps;
export default OrdersDataTable;



// WEBPACK FOOTER //
// ./src/components/OrdersDataTable/index.jsx